/* eslint-disable max-len */
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import pkg from '../../package.json';

export const environment = {
  production: false,
  wordpressUrl: 'https://nextgenrodeo.com/wp-content/APIUser.php',
  appVersion: pkg.version.replace('{','').replace('}',''),
  clientService: 'https://nextgenrodeo-develop-services-client.azurewebsites.net',
  // cientService: 'http://localhost:5000',
  notificationService: 'https://nextgenrodeo-develop-services-notifications.azurewebsites.net',
  notifications: 'https://nextgenrodeo-develop-services-notifications.azurewebsites.net',
  stripe: {
    publishableKey: 'pk_live_51LFggvAUmgIpCbTFR44RUi30H1eo9KtEWJtgg7sevwhlSgoXkIuXMNzIYLQc9rp9b76ga71Bjax1ameHMMrFFfiR00d0DBpOSb',
    testPublishableKey: 'pk_test_51LFggvAUmgIpCbTFss0riuCoyo3njhQ5OO7Tv5uPUhRdeNearPZwnTW5nMUJPRHDBhXA7mw2bsxM865KAlN01it200UqJZ5ezp',
    applePayMerchantId: 'merchant.com.nextgenrodeo.app',
    forceTestPayments: true,
    paymentMethodWebViewUrl: 'https://nextgendemo.z19.web.core.windows.net/mobile-app/add-customer-payment-method'
  },
  appInsightsConfig: {
    connectionString: 'InstrumentationKey=2967cb8c-4ae7-4ed3-9f54-5f70d86d96d5;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/',
    enableUnhandledPromiseRejectionTracking: true, //logs unhandled app crashes
    enableAjaxErrorStatusText: true, //logs dependency errors
    enableAjaxPerfTracking: true, //logs dependency calls
    overridePageViewDuration: true, //to grab pageview duration on nav end
    enableCorsCorrelation: true, //to correlate requests to server-side telemetry
    correlationHeaderExcludedDomains: [
      'ng-streaming-endpoint-1-nextgenmediaservices-usct.streaming.media.azure.net',
      'nextgenmediaservices-usct.streaming.media.azure.net'
    ]
  }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
